import { render, staticRenderFns } from "./ShippingDocumentList.vue?vue&type=template&id=2d86d984&scoped=true"
import script from "./ShippingDocumentList.vue?vue&type=script&lang=js"
export * from "./ShippingDocumentList.vue?vue&type=script&lang=js"
import style0 from "./ShippingDocumentList.vue?vue&type=style&index=0&id=2d86d984&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d86d984",
  null
  
)

export default component.exports